import useSearchParams from 'hooks/useSearchParams'

// UTM parameter keys that we want to track
const UTM_KEYS = [
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_term',
  'utm_content',
] as const

export type UtmParams = {
  utm_source?: string
  utm_medium?: string
  utm_campaign?: string
  utm_term?: string
  utm_content?: string
}

/**
 * Extracts UTM parameters from URL search params
 * @param searchParams - URLSearchParams object
 * @returns Object containing UTM parameters
 */
export const extractUtmParams = (searchParams: URLSearchParams): UtmParams => {
  const utmParams: UtmParams = {}

  UTM_KEYS.forEach((key) => {
    const value = searchParams.get(key)
    if (value) {
      utmParams[key] = value
    }
  })

  return utmParams
}

/**
 * Hook to get UTM parameters from current URL
 * @returns Object containing UTM parameters
 */
export const useUtmParams = (): UtmParams => {
  const searchParams = useSearchParams()

  if (!searchParams) {
    return {}
  }

  return extractUtmParams(searchParams)
}
